// extracted by mini-css-extract-plugin
export var cardHeader = "_et-0";
export var reorderHandle = "_et-3";
export var titleArea = "_et-1";
export var titleAreaWithHandle = "_et-2";